import { render, staticRenderFns } from "./ProjectLastComments.vue?vue&type=template&id=96ca8ecc&scoped=true"
import script from "./ProjectLastComments.vue?vue&type=script&lang=js"
export * from "./ProjectLastComments.vue?vue&type=script&lang=js"
import style0 from "./ProjectLastComments.vue?vue&type=style&index=0&id=96ca8ecc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ca8ecc",
  null
  
)

export default component.exports